const VERSION_LOG_STYLE =
  'background: #1a237e; color: #fff; font-size: 14px; padding: 4px 8px; border-radius: 4px;';

export function logAppVersion({ name, version, buildDate }) {
  console.log(
    `%c ${name} v${version} | compilado: ${buildDate} `,
    VERSION_LOG_STYLE
  );
}

export default logAppVersion;
